import { render, staticRenderFns } from "./CastCard.vue?vue&type=template&id=8cf9b83c&scoped=true&"
import script from "./CastCard.vue?vue&type=script&lang=js&"
export * from "./CastCard.vue?vue&type=script&lang=js&"
import style0 from "./CastCard.vue?vue&type=style&index=0&id=8cf9b83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf9b83c",
  null
  
)

export default component.exports